export const msalConfig = {
    auth: {
        clientId: "e3378777-202d-45d5-b6ed-1a419b25d115",
        authority: "https://login.microsoftonline.com/d44ff723-4fa7-405e-afc0-43c21e573043", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: "https://safelog.godrejenterprises.com/redirect",//new
        // redirectUri: "https://safelog.godrej.com/redirect",//new
        // redirectUri: 'http://localhost:3000/redirect',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"]
};
// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};